<template>
    <div class="svg-container">
        <svg id="ie-bar-chart"></svg>
    </div>
</template>

<script>
    import { gsap } from '/src/assets/js/gsap';
    import * as d3 from "d3";

    export default {
        name: 'BarChart',
        props : [ "chartData", "showEnding" ],
        data: function () {
            return {
                title: "Starting Engagement Scores"
            }
        },
        mounted () {
            const height = 800;
            const width = 800;
            const chartWidth = 600;
            const chartHeight = 600;
            const offset = 100; 
            const showEnding = this.showEnding;

            var svg = d3.select("#ie-bar-chart")
                .attr("width", width)
                .attr("height", height)
                .attr("viewBox", `0 0 800 800`)
                .attr("preserveAspectRatio", "xMidYMid meet")
                
            // X axis
            var x = d3.scaleBand() // chart labels
                .range([ 0, chartWidth ])
                .domain(this.chartData.map(function(d) { return d.label; }))
                .padding(0.2)
                
            svg.append("g") // chart transform and wrap
                .attr("class", "chart-style axis-x")
                .attr("transform", "translate(" + offset + "," + chartHeight + ")")
                .call(d3.axisBottom(x))
                
                .selectAll("text")
                .style("font-size", "13px")
                .call(this.wrap, 175)
                .attr("transform", "translate(-10,5)rotate(-45)")
                .style("text-anchor", "end");

            // Add Y axis
            var y = d3.scaleLinear()
                .domain([40, 100])
                .range([ chartHeight - 100, 0]);
            svg.append("g")
                .attr("class", "chart-style axis-y")
                .style("font-size", "15px")
                .call(d3.axisLeft(y))
                .attr("transform", "translate(" + offset + "," + offset + ")")                
            

            // Bars
            if (showEnding) {
                // left bar
                svg.selectAll("bars")
                    .data(this.chartData)
                    .enter()
                        .append("rect")
                        .attr("class", "bar")
                        .attr("x", function(d) { return x(d.label) + offset; })
                        .attr("y", function(d) { return y(d.baseline) + offset; })
                        .attr("width", x.bandwidth()/2)
                        .attr("height", function(d) { return (chartHeight - offset) - y(d.baseline); })
                        .attr("fill", "#4671c9");
                
                // text for left bar
                svg.selectAll("bars")
                    .data(this.chartData)
                    .enter()
                    .append("text")
                        .text(function(d) {                 
                            return d.baseline + "%";
                        })
                        .attr("class", "chart-style bar-text")
                        .attr("x", function(d) { return x(d.label) + offset + x.bandwidth()/4; })
                        .attr("y", function(d) { return y(d.baseline) + offset - 10; })
                        .attr("width", x.bandwidth()/2)
                        .attr("text-anchor", "middle")
                        .attr("font-size", "15px")

                // right data
                svg.selectAll("bars")
                    .data(this.chartData)
                    .enter()
                        .append("rect")
                        .attr("class", "bar")
                        .attr("x", function(d) { return x(d.label) + offset + x.bandwidth()/2; })
                        .attr("y", function(d) { return y(d.userScore) + offset; })
                        .attr("width", x.bandwidth()/2)
                        .attr("height", function(d) { return (chartHeight - offset) - y(d.userScore); })
                        .attr("fill", "#92d050");

                // text for right bar
                svg.selectAll("bars")
                    .data(this.chartData)
                    .enter()
                    .append("text")
                        .text(function(d) {                 
                            return d.userScore + "%";
                        })
                        .attr("class", "chart-style bar-text")
                        .attr("x", function(d) { return x(d.label) + offset + x.bandwidth()/4 + x.bandwidth()/2; })
                        .attr("y", function(d) { return y(d.userScore) + offset - 10; })
                        .attr("width", x.bandwidth()/2)
                        .attr("text-anchor", "middle")
                        .attr("font-size", "15px")

                // legend
                svg
                    .append("g") // chart transform and wrap
                    .attr("class", "legend")
                    .attr("transform", "translate(" + (chartWidth - 240) + "," + -40 + ")")
                    
                const legend = svg.select(".legend")
                legend.append("rect").attr("x",200).attr("y",124).attr("width", 12).attr("height", 12).style("fill", "#4671c9")
                legend.append("rect").attr("x",200).attr("y",154).attr("width", 12).attr("height", 12).style("fill", "#92d050")
                legend.append("text").attr("x", 220).attr("y", 130).text("Baseline").style("font-size", "15px").attr("alignment-baseline","middle")
                legend.append("text").attr("x", 220).attr("y", 160).text("Your Outcome").style("font-size", "15px").attr("alignment-baseline","middle")
                        
                
            } else {
                // single bar
                svg.selectAll("bars")
                    .data(this.chartData)
                    .enter()
                    .append("rect")
                        .attr("x", function(d) { return x(d.label) + offset + x.bandwidth()/4; })
                        .attr("y", function(d) { return y(d.baseline) + offset; })
                        .attr("width", x.bandwidth()/2)
                        .attr("height", function(d) { return (chartHeight - offset) - y(d.baseline); })
                        .attr("fill", "#4671c9")
                
                // text for top of bar
                svg.selectAll("bars")
                    .data(this.chartData)
                    .enter()
                    .append("text")
                        .text(function(d) {                 
                            return d.baseline + "%";
                        })
                        .attr("class", "chart-style bar-text")
                        .attr("x", function(d) { return x(d.label) + offset + x.bandwidth()/2; })
                        .attr("y", function(d) { return y(d.baseline) + offset - 10; })
                        .attr("width", x.bandwidth()/2)
                        .attr("text-anchor", "middle")
                        .attr("font-size", "15px")
            }

            // animate in bars and text, delay text
            gsap.from("#ie-bar-chart .bar", { scaleY:0, transformOrigin:"center bottom", stagger: { amount: 1}, delay: 0 })
            gsap.from("#ie-bar-chart text.bar-text", { autoAlpha: 0, stagger: { amount: 1}, delay: 0.5 })

        },
        methods: {
            wrap (text, width) {
                text.each(function() {
                    var text = d3.select(this),
                        words = text.text().split(/\s+/).reverse(),
                        word,
                        line = [],
                        lineNumber = 0,
                        lineHeight = 1.1, // ems
                        y = text.attr("y"),
                        dy = parseFloat(text.attr("dy")),
                        tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
                    while (word = words.pop()) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
                    }
                    }
                });
            }
        }  
    }
</script>
